import { Box, ButtonBase, Checkbox, Dialog, FormControlLabel, Grid, LinearProgress, LinearProgressProps, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import QualityCheckFileUploadPanel from "../components/QualityCheckFileUploadPanel";
import { useEffect, useState, useRef, useCallback } from "react";
import qualityCheckApi, { GlossaryItem } from "store/apis/qualityCheckApi";
import GlossaryPanel from "../components/GlossaryPanel";
import { LoadingButton } from "@mui/lab";
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { stompClient, registerConnectionCloseCallback } from "shared/StompClient";
import { GlossaryExtractJobStatusUpdateMessage } from "types/models/JobStatusUpdateMessage";
import { IMessage } from "@stomp/stompjs";
import { JobStatus } from "types/models/JobStatus";
// import { set } from "lodash";
import { useTranslation } from 'react-i18next';

type BuildGlossaryPanelProps = {
    isOpen: boolean
    onClose: () => void
    expandMyGlossary: () => void
}

const statusProgressMapping: { [key: string]: number } = {
    "PENDING": 0,
    "IN_PROGRESS": 20,
    "RUNNING_RETRIEVE_DOC": 40,
    "RUNNING_PARAGRAPH_SEGMENTATION": 40,
    "RUNNING_ALIGNMENT": 60,
    "RUNNING_EXTRACTION": 80,
    "COMPLETE": 100,
}

const BuildGlossaryPanel = (props: BuildGlossaryPanelProps) => {
    const { t } = useTranslation();

    const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);

    //api
    // const { data: user } = qualityCheckApi.useQualityCheckJobUserProfileQuery();
    const { data: myGlossaryList, refetch } = qualityCheckApi.useQualityCheckMyGlossaryListQuery();
    const [extractGlossary, { data: textData }] = qualityCheckApi.useQualityCheckGlossaryExtractMutation();
    const [extractGlossaryDoc, { data: docData }] = qualityCheckApi.useQualityCheckGlossaryExtractDocMutation();
    // const [initialChecking, { data: wordCount, isSuccess: isInitialCheckingSuccess, isLoading: isInitialChecking }] = qualityCheckApi.useQualityCheckInitialCheckingMutation();
    const [getGlossaryExtractResult] = qualityCheckApi.useQualityCheckGlossaryExtractResultMutation();

    //panel state
    const [jobId, setJobId] = useState(-1);
    const [status, setStatus] = useState("");
    const [progress, setProgress] = useState(0);
    const [inputType, setInputType] = useState<string | null>("text");
    const [textInput, setTextInput] = useState({ enP: "", zhP: "" });
    const [isOpenGlossaryDialog, setIsOpenGlossaryDialog] = useState(false);
    const [extractedGlossary, setExtractedGlossary] = useState<GlossaryItem[]>([]);
    const [connected, setConnected] = useState(false);
    const [isSaveToMyGlossary, setIsSaveToMyGlossary] = useState(false);
    const [myGlossaryName, setMyGlossaryName] = useState("");
    const [isValidArg, setIsValidArg] = useState(false);
    const [isOpenEditGlossary, setIsOpenEditGlossary] = useState(false);
    const [myGlossaryId, setMyGlossaryId] = useState(-1);
    
    // Derive selectedGlossaryItem from RTK Query data - auto-updates when list refetches
    const selectedGlossaryItem = myGlossaryList?.find(g => g.myGlossaryId === myGlossaryId);
    const [message, setMessage] = useState<GlossaryExtractJobStatusUpdateMessage>();
    
    // Refs for WebSocket subscription management
    const jobIdRef = useRef<number>(-1);
    const subscriptionRef = useRef<{ unsubscribe: () => void } | null>(null);
    const isSubscribedRef = useRef<boolean>(false);  // Prevent duplicate subscriptions

    // const [docCreditUsage, setDocCreditUsage] = useState(-1);
    // const [textCreditUsage, setTextCreditUsage] = useState(-1);

    const redirectUrl = process.env.REACT_APP_REDIRECT_URL;

    const [fileInput, setFileInput] = useState({
        enFile: [] as File[],
        zhFile: [] as File[],
    });

    // //start initial check 
    // useEffect(() => {
    //     if (textInput.enP.length !== 0 || textInput.zhP.length !== 0) {
    //         const enText = textInput.enP.match(/[^\u0000-\u2E7F]|[a-zA-Z0-9]+/g)?.length || 0;
    //         const zhText = textInput.zhP.match(/[^\u0000-\u2E7F]|[a-zA-Z0-9]+/g)?.length || 0;
    //         setTextCreditUsage(enText + zhText);
    //     } else {
    //         setTextCreditUsage(-1);
    //     }
    //     if (fileInput.enFile.length !== 0 && fileInput.zhFile.length !== 0) {
    //         initialChecking({ sourceFile: fileInput.enFile[0], targetFile: fileInput.zhFile[0] });
    //     } else {
    //         setDocCreditUsage(-1);
    //     }
    //     setJobId(-1);
    // }, [textInput, fileInput])

    //set credit usage
    // useEffect(() => {
    //     if (isInitialCheckingSuccess) {
    //         if (wordCount) {
    //             setDocCreditUsage(wordCount.sourceWordCount + wordCount.targetWordCount);
    //         }
    //     }
    // }, [isInitialCheckingSuccess])

    useEffect(() => {
        if (inputType === "text") {
            setIsValidArg(textInput.enP !== "" && textInput.zhP !== "")
        } else {
            setIsValidArg(fileInput.enFile.length !== 0 && fileInput.zhFile.length !== 0)
        }

        if (isSaveToMyGlossary) {
            if (myGlossaryName.length === 0 || myGlossaryList?.find(glossary => glossary.glossaryName === myGlossaryName) !== undefined) {
                setIsValidArg(false)
            }
        }
    }, [textInput, fileInput, isSaveToMyGlossary, myGlossaryName, inputType, myGlossaryList])

    useEffect(() => {
        setMyGlossaryName("");
    }, [isSaveToMyGlossary])

    useEffect(() => {
        if (myGlossaryId !== -1) {
            const selectedGlossary = myGlossaryList?.find(myGlossary => myGlossary.myGlossaryId === myGlossaryId);
            // Only open if glossary exists and panel is not already open
            if (selectedGlossary && !isOpenEditGlossary) {
                setIsOpenEditGlossary(true);
                setIsSaveToMyGlossary(false);
                setMyGlossaryName("");
            }
        }
    }, [myGlossaryId, myGlossaryList, isOpenEditGlossary])

    // Subscribe function that uses refs to get current jobId
    const subscribeToJob = useCallback((currentJobId: number) => {
        if (currentJobId === -1) return;
        
        // Prevent duplicate subscriptions for the same job
        if (isSubscribedRef.current && subscriptionRef.current) {
            return;
        }
        
        // Unsubscribe previous subscription if exists
        if (subscriptionRef.current) {
            try {
                subscriptionRef.current.unsubscribe();
            } catch (e) {
                // Ignore errors from unsubscribing stale subscription
            }
            subscriptionRef.current = null;
        }
        
        if (!stompClient.connected) {
            return;
        }
        
        subscriptionRef.current = stompClient.subscribe("/queue/job-result/glossary/" + currentJobId, async (msg: IMessage) => {
            const message: GlossaryExtractJobStatusUpdateMessage = JSON.parse(msg.body);
            setMessage(message);
        });
        isSubscribedRef.current = true;
    }, []);

    // Setup onConnect callback - this will be called when connection is established
    // NOTE: We do NOT chain originalOnConnect to prevent recursive calls
    const setupOnConnect = useCallback(() => {
        stompClient.onConnect = (frame) => {
            // Subscribe using the ref value (always current)
            if (jobIdRef.current !== -1) {
                subscribeToJob(jobIdRef.current);
            }
        };
    }, [subscribeToJob]);

    // When jobId changes, update ref and try to subscribe if connected
    useEffect(() => {
        jobIdRef.current = jobId;
        
        if (jobId === -1) {
            // Cleanup subscription when job is reset
            isSubscribedRef.current = false;
            if (subscriptionRef.current) {
                try {
                    subscriptionRef.current.unsubscribe();
                } catch (e) {
                    // Ignore
                }
                subscriptionRef.current = null;
            }
            return;
        }
        
        // Reset subscription flag for new job
        isSubscribedRef.current = false;
        
        // If already connected, subscribe immediately
        if (stompClient.connected) {
            subscribeToJob(jobId);
        }
    }, [jobId, subscribeToJob])

    // Reset subscription state when connection closes (for proper reconnection)
    useEffect(() => {
        const deregister = registerConnectionCloseCallback((evt) => {
            // Reset subscription state so onConnect can re-subscribe
            isSubscribedRef.current = false;
            subscriptionRef.current = null;
        });
        
        return () => {
            deregister();
        };
    }, []);

    useEffect(() => {
        if (message === undefined) return;
        const status = message.status;
        setStatus(status)
        if (message.status.includes("ERROR")) {
            setConnected(false);
            stompClient.deactivate();
            toast.error(message.status);
            setJobId(-1);
            setMessage(undefined);
            return;
        }
        setProgress(statusProgressMapping[status]);
        if (message.status === JobStatus.COMPLETE) {
            refetch().then(() => {
                stompClient.deactivate();
                setConnected(false);

                const myGlossaryId = message.myGlossaryId;

                if (!isSaveToMyGlossary) {
                    getGlossaryExtractResult({ uid: message.uuid }).unwrap().then((data: GlossaryItem[]) => {
                        setExtractedGlossary(data);
                        setIsOpenGlossaryDialog(true);
                    })
                } else {
                    setMyGlossaryId(myGlossaryId);
                }

                toast.success("Build glossary success!")
            });
        }
    }, [message, getGlossaryExtractResult, refetch])

    // Note: Reconnection is now handled by the onConnect callback in the jobId useEffect above
    // The stompClient will auto-reconnect (reconnectDelay: 300) and trigger onConnect

    const handleClosePanel = () => {
        props.onClose();
        setFileInput({ enFile: [], zhFile: [] });
        setTextInput({ enP: "", zhP: "" });
        setMyGlossaryName("");
        setIsSaveToMyGlossary(false);
        setJobId(-1);
        setConnected(false);
    }

    const createUploadHandler = (type: string) => (file: File[]) => {
        setFileInput(prevState => ({
            ...prevState,
            [`${type}File`]: file,
        }));
    };

    const handleChangeInputType = (event: React.MouseEvent<HTMLElement>, newInputType: string | null) => {
        if (newInputType !== null) {
            setInputType(newInputType);
        }
    }

    const handleSubmitGlossaryExtract = async () => {
        // Reset previous job state
        setJobId(-1);
        setMessage(undefined);
        setProgress(0);
        setStatus(t('glossary.build.pending'));
        isSubscribedRef.current = false;  // Reset subscription flag for new job
        
        if (isLoggedIn) {
            // if (user?.subscriptionStatus === "INACTIVE") {
            //     if (user?.creditBalance < (inputType === "text" ? textCreditUsage : docCreditUsage)) {
            //         toast.error("Insufficient credit balance, please top-up or subscribe Addcuracy+ to continue!")
            //         return;
            //     }
            // }
        } else {
            window.location.href = redirectUrl!;
            return;
        }
        
        // Setup onConnect callback BEFORE activating - this is critical!
        setupOnConnect();
        
        // Only activate if not already connected - avoid unnecessary reconnection
        if (!stompClient.connected) {
            stompClient.activate();
        }
        setConnected(true)
        const id = toast.loading(t('glossary.build.pendingExtract'))
        if (inputType === "text") {
            await extractGlossary({ enP: textInput.enP, zhP: textInput.zhP, isSaveToMyGlossary: isSaveToMyGlossary, myGlossaryName: myGlossaryName }).unwrap().then((data) => {
                toast.update(id, { render: t('glossary.build.submitSuccess'), type: "success", isLoading: false, autoClose: 2000 })
                setJobId(data.jobId)
            }).catch((e) => {
                toast.update(id, { render: t('glossary.build.submitFail'), type: "error", isLoading: false, autoClose: 2000 })
            });
        } else {
            await extractGlossaryDoc({ enFile: fileInput.enFile[0], zhFile: fileInput.zhFile[0], isSaveToMyGlossary: isSaveToMyGlossary, myGlossaryName: myGlossaryName }).unwrap().then((data) => {
                toast.update(id, { render: t('glossary.build.submitSuccess'), type: "success", isLoading: false, autoClose: 2000 })
                setJobId(data.jobId)
            }).catch((e) => {
                toast.update(id, { render: t('glossary.build.submitFail'), type: "error", isLoading: false, autoClose: 2000 })
            });
        }
    }

    const textFieldZone = (kind: 'source' | 'target') => {

        const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            if (kind === 'source') {
                setTextInput({ ...textInput, enP: event.target.value })
            } else {
                setTextInput({ ...textInput, zhP: event.target.value })
            }
        };

        return (
            <Grid container spacing={1}>
                <Grid item xs={12} style={{ paddingTop: "10px" }}>
                    <Typography variant="h6" id="modal-title">
                        {kind === 'source' ? t('createJob.documentTypes.source') : t('createJob.documentTypes.target')}
                    </Typography>
                    <TextField
                        multiline
                        variant="outlined"
                        fullWidth
                        rows={8}
                        margin="normal"
                        onChange={handleTextChange}
                        inputProps={{ style: { fontSize: "10px" } }}
                        value={kind === 'source' ? textInput.enP : textInput.zhP}
                    />
                </Grid>
            </Grid>
        )
    }

    const LinearProgressWithLable = (props: LinearProgressProps & { value: number }) => {

        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant="determinate" {...props} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" color="text.secondary">{`${Math.round(
                        props.value,
                    )}%`}</Typography>
                </Box>
            </Box>
        );
    }

    return (
        <>
            <GlossaryPanel
                mode="edit"
                isOpen={isOpenEditGlossary}
                existingGlossary={selectedGlossaryItem}
                onClickClose={() => { 
                    setIsOpenEditGlossary(false); 
                    setMyGlossaryId(-1);
                }}
            />
            {
                (textData || docData) &&
                <GlossaryPanel
                    mode="create"
                    isOpen={isOpenGlossaryDialog}
                    glossaryItems={extractedGlossary}
                    onClickClose={() => { setIsOpenGlossaryDialog(false); setExtractedGlossary([]); }}
                    expandMyGlossary={props.expandMyGlossary}
                    isBuildGlossary={true}
                />
            }
            <Dialog
                open={props.isOpen}
                onBackdropClick={handleClosePanel}
                maxWidth={"md"}
                PaperProps={{ sx: { borderRadius: "10px", padding: "20px", height: "fitContent", justifyContent: "space-between" } }}
            >
                <Grid container spacing={2} height={"maxContent"}>
                    <Grid item xs={12} sx={{ display: "flex", flexDirection: "column" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <Typography variant="h5" gutterBottom>
                                {t('glossary.build.title')}
                            </Typography>
                            <ButtonBase onClick={handleClosePanel}>
                                <CloseIcon />
                            </ButtonBase>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                {t('glossary.build.description')}
                            </Typography>
                            <ToggleButtonGroup
                                value={inputType}
                                onChange={handleChangeInputType}
                                exclusive
                                sx={{ height: "35px" }}
                            >
                                <ToggleButton value="text">
                                    {t('glossary.build.inputText')}
                                </ToggleButton>
                                <ToggleButton value="file">
                                    {t('glossary.build.inputFile')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingTop: "10px", paddingLeft: "32px" }}>
                        {inputType === "file" ?
                            <QualityCheckFileUploadPanel
                                documentType="source"
                                document={fileInput.enFile}
                                onDrop={createUploadHandler('en')}
                                supportDocTypeOverride={[".docx"]}

                            />
                            :
                            <Box height={274}>
                                {textFieldZone('source')}
                            </Box>
                        }
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ paddingTop: "10px", paddingLeft: "32px" }}>
                        {inputType === "file" ?
                            <QualityCheckFileUploadPanel
                                documentType="target"
                                document={fileInput.zhFile}
                                onDrop={createUploadHandler('zh')}
                                supportDocTypeOverride={[".docx"]}
                            />
                            :
                            <Box height={274}>
                                {textFieldZone('target')}
                            </Box>
                        }
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "0px" }}>
                        <FormControlLabel
                            control={<Checkbox sx={{ "&.Mui-checked": { color: "black" } }} />}
                            label={t('glossary.build.saveToMyGlossary')}
                            checked={isSaveToMyGlossary}
                            onChange={() => { setIsSaveToMyGlossary(!isSaveToMyGlossary) }}
                        />
                        {isSaveToMyGlossary &&
                            <TextField
                                sx={{
                                    borderColor: "black",
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "black"
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: 'black'
                                        }
                                    },
                                }}
                                label={<span color="black">{t('glossary.build.glossaryName')}</span>}
                                variant="outlined"
                                value={myGlossaryName}
                                onChange={(event) => { setMyGlossaryName(event.target.value) }}
                                error={myGlossaryName.length === 0 || myGlossaryList?.find(glossary => glossary.glossaryName === myGlossaryName) !== undefined}
                                helperText={myGlossaryName.length === 0 ? t('glossary.build.glossaryNameEmpty') : myGlossaryList?.find(glossary => glossary.glossaryName === myGlossaryName) !== undefined ? t('glossary.build.glossaryNameExist') : ''}
                            />
                        }
                    </Grid>
                    {/* <Grid item xs={12} sx={{ paddingTop: "10px", paddingLeft: "32px" }}>
                        {inputType === "file" ?
                            <Typography>
                                {"Credit Usage: "} {docCreditUsage !== -1 && docCreditUsage} {isInitialChecking && "calculating..."}
                            </Typography>
                            :
                            <Typography>
                                {"Credit Usage: "} {textCreditUsage !== -1 && textCreditUsage}
                            </Typography>
                        }
                    </Grid> */}
                </Grid>
                <Box
                    sx={{ display: "flex", justifyContent: "center" }}
                >
                    <LoadingButton
                        onClick={handleSubmitGlossaryExtract}
                        loading={connected}
                        disabled={!isValidArg}
                        sx={{ width: "fit-content" }}
                    >
                        {t('glossary.build.generate')}
                    </LoadingButton>
                </Box>
                {
                    jobId !== -1 &&
                    <Box sx={{ width: '100%' }}>
                        <Typography color={"gray"}>{status}</Typography>
                        <LinearProgressWithLable value={progress} />
                    </Box>
                }
            </Dialog >
        </>


    )
}

export default BuildGlossaryPanel;